"use strict";
/**
* lodashMini.ts
*
* Copyright (c) Microsoft Corporation. All rights reserved.
* Licensed under the MIT license.
*
* Import and re-export of part of the lodash module. This helps reduce bundle size.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var assign = require("lodash/assign");
exports.assign = assign;
var clone = require("lodash/clone");
exports.clone = clone;
var cloneDeep = require("lodash/cloneDeep");
exports.cloneDeep = cloneDeep;
var defer = require("lodash/defer");
exports.defer = defer;
var each = require("lodash/each");
exports.each = each;
var endsWith = require("lodash/endsWith");
exports.endsWith = endsWith;
var extend = require("lodash/extend");
exports.extend = extend;
var filter = require("lodash/filter");
exports.filter = filter;
var findIndex = require("lodash/findIndex");
exports.findIndex = findIndex;
var findLast = require("lodash/findLast");
exports.findLast = findLast;
var flatten = require("lodash/flatten");
exports.flatten = flatten;
var get = require("lodash/get");
exports.get = get;
var isArray = require("lodash/isArray");
exports.isArray = isArray;
var isEmpty = require("lodash/isEmpty");
exports.isEmpty = isEmpty;
var isEqual = require("lodash/isEqual");
exports.isEqual = isEqual;
var isNumber = require("lodash/isNumber");
exports.isNumber = isNumber;
var isObject = require("lodash/isObject");
exports.isObject = isObject;
var isUndefined = require("lodash/isUndefined");
exports.isUndefined = isUndefined;
var kebabCase = require("lodash/kebabCase");
exports.kebabCase = kebabCase;
var keys = require("lodash/keys");
exports.keys = keys;
var map = require("lodash/map");
exports.map = map;
var mapValues = require("lodash/mapValues");
exports.mapValues = mapValues;
var max = require("lodash/max");
exports.max = max;
var memoize = require("lodash/memoize");
exports.memoize = memoize;
var merge = require("lodash/merge");
exports.merge = merge;
var omit = require("lodash/omit");
exports.omit = omit;
var remove = require("lodash/remove");
exports.remove = remove;
var throttle = require("lodash/throttle");
exports.throttle = throttle;
var union = require("lodash/union");
exports.union = union;



//////////////////
// WEBPACK FOOTER
// ./~/reactxp/dist/web/utils/lodashMini.js
// module id = 7
// module chunks = 0